// import React from "react";
// import "./WhatWeDo.css";
// import { motion } from "framer-motion";
// import Tilt from "react-parallax-tilt";

// // Sample images
// import layout from "../assets/layout.jpeg";
// import brand from "../assets/brand.jpeg";

// // Replace these with your actual OneDrive links
// const services = [
//   {
//     title: "Book Writing & Proofreading",
//     description:
//       "Crafting original, curriculum-based content and ensuring error-free, polished material through professional proofreading.",
//     icon: "https://img.icons8.com/color/96/book.png",
//     link: "https://onedrive.live.com/?redeem=aHR0cHM6Ly8xZHJ2Lm1zL2YvYy9jMmQ3MjA0ZGE5NWViYzNlL0VqNjhYcWxOSU5jZ2dNS29QUUFBQUFBQjVudGdxMklEWWdQVGF4WjdtQmhxZmc%5FZT1pbmhLbkg&id=C2D7204DA95EBC3E%21sbb047566bb6645c7ade51b9e51625384&cid=C2D7204DA95EBC3E&sb=name&sd=1", // Replace with actual link
//   },
//   {
//     title: "Typesetting & Layout Design",
//     description:
//       "Professional formatting using CorelDRAW and InDesign to structure educational content.",
//     icon: layout,
//     link: "https://onedrive.live.com/?redeem=aHR0cHM6Ly8xZHJ2Lm1zL2YvYy9jMmQ3MjA0ZGE5NWViYzNlL0VqNjhYcWxOSU5jZ2dNS29QUUFBQUFBQjVudGdxMklEWWdQVGF4WjdtQmhxZmc%5FZT1pbmhLbkg&id=C2D7204DA95EBC3E%21s19ce979f59884df1a4da7f65aed93e4f&cid=C2D7204DA95EBC3E&sb=name&sd=1",
//   },
//   {
//     title: "Illustration & 2D Animation",
//     description:
//       "Creating engaging illustrations and animated 2D visuals to enhance learning and textbook content.",
//     icon: "https://img.icons8.com/color/96/animation.png",
//     link: "https://onedrive.live.com/?redeem=aHR0cHM6Ly8xZHJ2Lm1zL2YvYy9jMmQ3MjA0ZGE5NWViYzNlL0VqNjhYcWxOSU5jZ2dNS29QUUFBQUFBQjVudGdxMklEWWdQVGF4WjdtQmhxZmc%5FZT1pbmhLbkg&id=C2D7204DA95EBC3E%21s290d2e83ba7447e0ac1cd0595b7ccc77&cid=C2D7204DA95EBC3E&sb=name&sd=1",
//   },
//   {
//     title: "Educational Video Production with QR Integration",
//     description:
//       "Creating curriculum-aligned video lessons and linking them seamlessly to textbooks via scannable QR codes.",
//     icon: "https://img.icons8.com/color/96/video.png",
//     link: "https://onedrive.live.com/?redeem=aHR0cHM6Ly8xZHJ2Lm1zL2YvYy9jMmQ3MjA0ZGE5NWViYzNlL0VqNjhYcWxOSU5jZ2dNS29QUUFBQUFBQjVudGdxMklEWWdQVGF4WjdtQmhxZmc%5FZT1pbmhLbkg&id=C2D7204DA95EBC3E%21sbb047566bb6645c7ade51b9e51625384&cid=C2D7204DA95EBC3E&sb=name&sd=1",
//   },
//   {
//     title: "Corporate Visual Production",
//     description:
//       "High-quality photoshoots, videography, and full production for brands, events, and promotions.",
//     icon: "https://img.icons8.com/color/96/camera.png",
//     link: "https://onedrive.live.com/?redeem=aHR0cHM6Ly8xZHJ2Lm1zL2YvYy9jMmQ3MjA0ZGE5NWViYzNlL0VqNjhYcWxOSU5jZ2dNS29QUUFBQUFBQjVudGdxMklEWWdQVGF4WjdtQmhxZmc%5FZT1pbmhLbkg&id=C2D7204DA95EBC3E%21s6cf8b3ce84954088a66fb587562fa66e&cid=C2D7204DA95EBC3E&sb=name&sd=1",
//   },
//   {
//     title: "Branding & Advertising",
//     description:
//       "Building strong brand identities and executing targeted advertising strategies.",
//     icon: brand,
//     link: "https://onedrive.live.com/your-onedrive-link-6",
//   },
//   {
//     title: "Social Media Marketing (SMM)",
//     description:
//       "Managing educational brands via content creation and engagement across platforms.",
//     icon: "https://img.icons8.com/color/96/share--v1.png",
//     link: "https://onedrive.live.com/?redeem=aHR0cHM6Ly8xZHJ2Lm1zL2YvYy9jMmQ3MjA0ZGE5NWViYzNlL0VqNjhYcWxOSU5jZ2dNS29QUUFBQUFBQjVudGdxMklEWWdQVGF4WjdtQmhxZmc%5FZT1pbmhLbkg&id=C2D7204DA95EBC3E%21se649c1cae75c4ef58ab4334d4777d896&cid=C2D7204DA95EBC3E&sb=name&sd=1",
//   },
// ];

// const WhatWeDo = () => {
//   return (
//     <section className="whatwedo-container">
//       <motion.h2
//         className="section-title"
//         initial={{ opacity: 0, y: -40 }}
//         whileInView={{ opacity: 1, y: 0 }}
//         transition={{ duration: 0.8 }}
//       >
//         What We Do
//       </motion.h2>

//       <div className="services-bar">
//         {services.map((service, index) => (
//           <motion.div
//             key={index}
//             className="motion-wrapper"
//             initial={{ opacity: 0, scale: 0.9 }}
//             whileInView={{ opacity: 1, scale: 1 }}
//             transition={{ duration: 0.5, delay: index * 0.15 }}
//             viewport={{ once: true }}
//           >
//             <Tilt
//               glareEnable={true}
//               glareMaxOpacity={0.2}
//               glareColor="#fff"
//               tiltMaxAngleX={10}
//               tiltMaxAngleY={10}
//             >
//               <motion.div
//                 className="service-block1"
//                 whileHover={{
//                   scale: 1.05,
//                   boxShadow: "0px 10px 20px rgba(0,0,0,0.2)",
//                 }}
//               >
//                 <div className="iconcircle" title={service.title}>
//                   <img src={service.icon} alt={service.title} />
//                 </div>
//                 <div className="triangle-down"></div>
//                 <h4 className="service-title">{service.title}</h4>
//                 <p className="service-desc">{service.description}</p>

//                 {/* Use anchor tag for external links */}
//                 <a
//                   href={service.link}
//                   className="service-button"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                 >
//                   More Info
//                 </a>
//               </motion.div>
//             </Tilt>
//           </motion.div>
//         ))}
//       </div>
//     </section>
//   );
// };

// export default WhatWeDo;

import React from "react";
import "./WhatWeDo.css";
import { motion } from "framer-motion";
import Tilt from "react-parallax-tilt";
import { Link } from "react-router-dom";

// Sample images
import layout from "../assets/layout.jpeg";
import brand from "../assets/brand.jpeg";

const services = [
  {
    title: "Book Writing & Proofreading",
    description:
      "Crafting original, curriculum-based content and ensuring error-free, polished material through professional proofreading.",
    icon: "https://img.icons8.com/color/96/book.png",
    linkType: "route",
    routePath: "/book-writing",
  },
  {
    title: "Typesetting & Layout Design",
    description:
      "Professional formatting using CorelDRAW and InDesign to structure educational content.",
    icon: layout,
    linkType: "route",
    routePath: "/typesetting-layout",
  },
  {
    title: "Illustration & 2D Animation",
    description:
      "Creating engaging illustrations and animated 2D visuals to enhance learning and textbook content.",
    icon: "https://img.icons8.com/color/96/animation.png",
    linkType: "direct",
    link: "https://www.youtube.com/playlist?list=PLbDaRtxKq_0VUfV7ZTz1LLNzq_wTEJ3IT",
  },
  {
    title: "Educational Video Production with QR Integration",
    description:
      "Creating curriculum-aligned video lessons and linking them seamlessly to textbooks via scannable QR codes.",
    icon: "https://img.icons8.com/color/96/video.png",
    linkType: "direct",
    link: "https://www.youtube.com/playlist?list=PLbDaRtxKq_0VoTiDiYi8MCWdrX-tNjgvq",
  },
  {
    title: "Corporate Visual Production",
    description:
      "High-quality photoshoots, videography, and full production for brands, events, and promotions.",
    icon: "https://img.icons8.com/color/96/camera.png",
    linkType: "direct",
    link: "https://www.youtube.com/playlist?list=PLbDaRtxKq_0WBePu_c9XzSZCN54KHakMx",
  },
  {
    title: "Branding & Advertising",
    description:
      "Building strong brand identities and executing targeted advertising strategies.",
    icon: brand,
    linkType: "route",
    routePath: "/branding-advertising",
  },
  {
    title: "Social Media Marketing (SMM)",
    description:
      "Managing educational brands via content creation and engagement across platforms.",
    icon: "https://img.icons8.com/color/96/share--v1.png",
    linkType: "route",
    routePath: "/social-media-marketing",
  },
];

const WhatWeDo = () => {
  return (
    <section className="whatwedo-container" id = "services">
      <motion.h2
        className="section-title"
        initial={{ opacity: 0, y: -40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        What We Do
      </motion.h2>

      <div className="services-bar">
        {services.map((service, index) => (
          <motion.div
            key={index}
            className="motion-wrapper"
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5, delay: index * 0.15 }}
            viewport={{ once: true }}
          >
            <Tilt glareEnable glareMaxOpacity={0.2}>
              <motion.div
                className="service-block1"
                whileHover={{
                  scale: 1.05,
                  boxShadow: "0px 10px 20px rgba(0,0,0,0.2)",
                }}
              >
                <div className="iconcircle">
                  <img src={service.icon} alt={service.title} />
                </div>

                <div className="triangle-down"></div>
                <h4 className="service-title">{service.title}</h4>
                <p className="service-desc">{service.description}</p>

                {/* Conditional navigation */}
                {service.linkType === "direct" ? (
                  <a
                    href={service.link}
                    className="service-button"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    More Info
                  </a>
                ) : (
                  <Link to={service.routePath} className="service-button">
                    More Info
                  </Link>
                )}
              </motion.div>
            </Tilt>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default WhatWeDo;
